<template>
  <div class="postPrev">
    <div
      v-for="(pic, index) in post.media"
      :key="index"
    >
      <img 
        :src="pic.thumbnail" 
        class="img-fluid">
    </div>
    <div
      v-linkified
      v-html="post.message || post.raw.full_text"/>
    <div>
      Posted on {{ date }}
    </div> 
    <div>
      <a
        :href="post.url"
        target="_blank">
        {{ post.source || 'Twitter' }}
      </a>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "PostPreview",
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  computed: {
    date() {
      return moment(this.post.date).toString();
    }
  }
};
</script>

<style scoped>
.card {
  border: 0.3em solid rgba(66, 66, 66, 0.15) !important;
  padding: 0;
}
.postPrev {
  max-width: 100%;
  padding: 10px;
  overflow-wrap: break-word;
}
.img-fluid {
  max-width: 100% !important;
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PostPreview.vue